import * as types from "./actionTypes.js";
import * as apiUrls from './apiUrls';

import Cookies from "universal-cookie";

const cookies = new Cookies();

export function fetchTradeSupportingDocuments(
  userID,
  tradeDocumentType,
  tradeDocumentID,
  loadingCallback
) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2UserTradeSupportingDocuments(
      userID,
      tradeDocumentType,
      tradeDocumentID,
    ), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => response.json())
    .then(json => {
      loadingCallback();
      return dispatch(receiveTradeSupportingDocuments(json))
    })
    .catch(error => {
      loadingCallback();
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function submitTradeSupportingDocument(
  userID,
  tradeDocumentType,
  tradeDocumentID,
  body,
  successCallback,
) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2UserTradeSupportingDocuments(
      userID,
      tradeDocumentType,
      tradeDocumentID,
    ), {
      method: "POST",
      headers: new Headers({
        "Authorization": cookies.get("jwtToken"),
      }),
      body,
    })
    .then(response => response.json())
    .then((data) => {
      const { id, trade_supporting_attachments } = data;

      const payload = {
        id,
        trade_supporting_attachments,
      };

      successCallback();
      return dispatch(createTradeSupportingDocuments(payload));
    })
  };
}

export function deleteTradeSupportingDocument(
  userID,
  tradeDocumentType,
  tradeDocumentID,
  id,
  successCallback,
) {
  return(dispatch) => {
    return fetch(apiUrls.apiV2UserTradeSupportingDocument(
      userID,
      tradeDocumentType,
      tradeDocumentID,
      id,
      successCallback,
    ), {
      method: "DELETE",
      headers: new Headers({
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(() => {
      successCallback();
      return dispatch(removeTradeSupportingDocument(id));
    })
  }
}


export function receiveTradeSupportingDocuments(data) {
  return { type: types.RECEIVE_TRADE_SUPPORTING_DOCUMENTS, payload: data };
}

export function createTradeSupportingDocuments(data) {
  return { type: types.CREATE_TRADE_SUPPORTING_DOCUMENTS, payload: data };
}

export function removeTradeSupportingDocument(id) {
  return { type: types.REMOVE_TRADE_SUPPORTING_DOCUMENT, payload: id }
}

export function removeTradeSupportingDocuments() {
  return { type: types.REMOVE_TRADE_SUPPORTING_DOCUMENTS, payload: [] }
}



// WEBPACK FOOTER //
// ./src/features/supporting_documents/actions.js